<template>
  <div class="content">
    <div class="topbox">
      <div class="pointbox flex">
        <div class="left">
          <div class="name">{{pointCode}}</div>
          <div class="text">
            <div>门店名称：{{form.shopName || ''}}</div>
            <div>所属楼栋：{{form.buildName || ''}}</div>
            <div>点位名称：{{form.pointName || ''}}</div>
            <div>所属楼层：{{form.floorName || ''}}</div>
          </div>
        </div>
        <div class="right flex-center">
          <div class="time">{{newtimename}}</div>
          <div class="tit">今日打卡任务</div>
          <div class="num">{{form.complete}}/{{form.total}}</div>
        </div>
      </div>
      <div class="desc">
        <div class="left">
          <img src="@/assets/take.png"/>
          <div>注意</div>
          <div>事项</div>
        </div>
        <div class="right">{{form.memo}}</div>
      </div>
    </div>
    <div v-if="list.length>0">
      <div class="title1">当前任务段</div>
      <div class="list">
        <div class="item" :class="item.patrolStatus==0 || item.patrolStatus==1?'bcolor':item.patrolStatus==1 || item.patrolStatus==2 || item.patrolStatus==3?'rcolor':item.patrolStatus==4?'lvcolor':''" v-for="(item,index) in list" :key="index" @click="getshow(item)">
          <div class="flex">
            <img src="@/assets/abnormal.png" v-if="item.patrolStatus==3"/>
            <img src="@/assets/cel.png" v-if="item.patrolStatus==-1"/>
            <img src="@/assets/cuo.png" v-if="item.patrolStatus==2"/>
            <img src="@/assets/finish.png" v-if="item.patrolStatus==4"/>
            <img src="@/assets/finish1.png" v-if="item.patrolStatus==0"/>
            <img src="@/assets/time.png" v-if="item.patrolStatus==1"/>
            <div class="left">
              <div v-if="item.missionStartTime && item.missionStartTime!=''" :class="{scolor2:item.patrolStatus==3}">{{periodicType==3?'检查':typename}}时间：{{gettime(item.missionStartTime)}}-{{gettime(item.missionEndTime)}}</div>
              <div >{{periodicType==3?'检查':typename}}点位：{{item.pointName || ''}}</div>

              <div>所属楼栋：{{item.buildName}}</div>
              <div>预计{{periodicType==3?'检查':typename}}人：
                <span class="tname" v-if="item.outsidersList!=null && item.outsidersList.length>0" v-for="(otem,nindex) in item.outsidersList" :key="nindex">{{otem.systemOutsidersName}}<span>、</span></span>
              </div>
              <div>任务状态：{{getstateName(item.patrolStatus)}}</div>
            </div>
            <div class="right" v-if="item.patrolStatus>=0 && item.patrolStatus<=3 && item.isshow && isuser==2" @click.stop="getshow(item)">{{typename}}打卡</div>
          </div>
        </div>
      </div>
    </div>
    
    <div v-if="list1.length>0">
      <div class="title1">其他时段任务</div>
      <div class="list">
        <div class="item" :class="item.patrolStatus==0 || item.patrolStatus==1?'bcolor':item.patrolStatus==1 || item.patrolStatus==2 || item.patrolStatus==3?'rcolor':item.patrolStatus==4?'lvcolor':''" v-for="(item,index) in list1" :key="index" @click="getshow(item)">
          <div class="flex">
            <img src="@/assets/abnormal.png" v-if="item.patrolStatus==3"/>
            <img src="@/assets/cel.png" v-if="item.patrolStatus==-1"/>
            <img src="@/assets/cuo.png" v-if="item.patrolStatus==2"/>
            <img src="@/assets/finish.png" v-if="item.patrolStatus==4"/>
            <img src="@/assets/finish1.png" v-if="item.patrolStatus==0"/>
            <img src="@/assets/time.png" v-if="item.patrolStatus==1"/>
            <div class="left">
              <div v-if="item.missionStartTime && item.missionStartTime!=''" :class="{scolor2:item.patrolStatus==3}">{{typename}}时间：{{gettime(item.missionStartTime)}}-{{gettime(item.missionEndTime)}}</div>
              <div >{{typename}}点位：{{item.pointName || ''}}</div>
              <div>所属楼栋：{{item.buildName}}</div>
              <div>预计{{typename}}人：
                <span class="tname" v-if="item.outsidersList!=null && item.outsidersList.length>0" v-for="(otem,nindex) in item.outsidersList" :key="nindex">{{otem.systemOutsidersName}}<span>、</span></span>
              </div>
              <div>任务状态：{{getstateName(item.patrolStatus)}}</div>
            </div>
            <div class="right" v-if="item.patrolStatus>=0 && item.patrolStatus<=3 && item.isshow && isuser==2" @click.stop="getshow(item)">{{typename}}打卡</div>
          </div>
        </div>
      </div>
      <!-- <task-list type="pointlist" :list="list1" @getup="getList()"></task-list> -->
    </div>
    <van-popup
      v-model="show"
      closeable
      position="bottom"
      round>
        <div class="pop_box">
            <div class="title">{{typename}}打卡</div>
            <van-form class="max60" :show-error-message="false" :scroll-to-error="true" @submit="goSubmit">
                <van-cell-group inset>
                    <van-field v-model="formtwo.name" readonly name="name" :label="typename+'人'" :placeholder="typename+'人'" :label-width="60" :rules="[{ required: true, message: typename+'人不能为空' }]"></van-field>
                    <van-field v-model="formtwo.newtime" readonly name="newtime" :label="typename+'时间'" :placeholder="typename+'人'" :label-width="60"></van-field>
                    <van-field :required="true" label="是否有异常" :label-width="70">
                        <template #input>
                            <div class="row-end">
                                <van-switch v-model="formtwo.pointStatus" inactive-color="#ddd"/>
                            </div>
                            <!-- <van-switch v-model="formtwo.pointStatus" inactive-color="#ddd" /> -->
                        </template>
                    </van-field>
                    <div v-for="(item,index) in formtwo.itemList" :key="index">
                        <van-field :label="'细化确认项'+(index+1)+'：'" :label-width="180"></van-field>
                        <van-field :label="item.itemName" :name="'itemList.' + index + '.itemValue'">
                            <template #input>
                                <div class="row-end">
                                <van-radio-group v-model="item.itemValue" class="row-end">
                                        <van-radio name="1">正常</van-radio>
                                        <van-radio name="0">异常</van-radio>
                                    </van-radio-group>
                                </div>
                                <!-- <van-switch v-model="formtwo.pointStatus" inactive-color="#ddd" /> -->
                            </template>
                        </van-field>
                        <van-field label="照片" :required="item.requiredPhoto==1?true:false" :label-width="60" :name="'itemList.' + index + '.imgUrl'" :rules="[{ required: item.requiredPhoto==1?true:false, message: '请上传照片' }]">
                            <template #input>
                                <van-uploader v-model="formtwo.itemList[index].imgUrltwo" multiple :max-count="1" :after-read="(file)=>afterRead(file, index)" :before-read="beforeRead" @delete="(file, detail) => deleteImg(file, detail,index)"/>
                            </template>
                        </van-field>
                        <van-field type="textarea" rows="2" autosize v-model="item.memo" :name="'itemList.' + index + '.memo'" label="备注" placeholder="备注" :label-width="60" maxlength="200" readonly></van-field>
                    </div>
                    <van-field v-if="formtwo.missionType==1 || formtwo.missionType==3" required type="textarea" rows="2" autosize v-model="formtwo.patrolMemo" name="patrolMemo" label="巡查情况" placeholder="巡查情况" :label-width="60" maxlength="200" :rules="[{ required: true, message: '巡查情况不能为空' }]"></van-field>
                    <van-field v-if="formtwo.missionType==2" type="textarea" rows="2" autosize v-model="formtwo.constructionUnit" name="constructionUnit" label="施工单位" placeholder="施工单位" :label-width="60" maxlength="20" :rules="[{ required: true, message: '施工单位不能为空' }]"></van-field>
                    <van-field v-if="formtwo.missionType==2" v-model="formtwo.constructionPersonnel" name="constructionPersonnel" type="number" label="施工人数" placeholder="施工人数" :label-width="60" maxlength="20" :rules="[{ required: true, message: '施工人数不能为空' }]"></van-field>
                    <van-field v-if="formtwo.missionType==2" type="textarea" rows="2" autosize v-model="formtwo.constructionMemo" name="constructionMemo" label="施工内容" placeholder="施工内容" :label-width="60" maxlength="200" :rules="[{ required: true, message: '施工内容不能为空' }]"></van-field>
                    <van-field v-if="formtwo.missionType==2" type="textarea" rows="2" autosize v-model="formtwo.dangerousMemo" name="dangerousMemo" label="隐患内容" placeholder="隐患内容" :label-width="60" maxlength="200" :rules="[{ required: true, message: '隐患内容不能为空' }]"></van-field>
                    <van-field :required="formtwo.requiredPhoto==1?true:false" label="现场照片" :label-width="60" name="picUrlList" :rules="[{ required: formtwo.requiredPhoto==1?true:false, message: '请上传现场照片' }]">
                        <template #input>
                            <van-uploader v-model="formtwo.picUrlList" multiple :max-count="5" :after-read="(file)=>afterRead(file, '')" :before-read="beforeRead" @delete="(file, detail) => deleteImg(file, detail,-1)"/>
                        </template>
                    </van-field>
                    
                </van-cell-group>
                <div class="btn_box">
                    <van-button round block type="primary" color="linear-gradient(55deg, #6261DB 0%, #3332B5 100%)" size="middle" @click="gettot()" v-if="formtwo.picUrlList.length==0 && formtwo.requiredPhoto==1">确认</van-button>
                    <van-button round block type="primary" color="linear-gradient(55deg, #6261DB 0%, #3332B5 100%)" size="middle" native-type="submit" :loading="loading" v-else>确认</van-button>
                </div>
            </van-form>
        </div>
      </van-popup>

      <van-popup v-model="showpop" round closeable>
        <div class="show_box">
          <img v-if="xgwc" src="@/assets/finish.png"/>
          <img v-if="xgsb" src="@/assets/cuo.png"/>
          <div class="txt">{{txt}}</div>
          <div class="btnfoot">
              <van-button round block type="primary" color="#0283ef" size="middle"  @click="gourl(formtwo)" v-if="xgsb">任务详情</van-button>
              <van-button round block type="primary" color="#0283ef" size="middle" @click="goindex()" :class="{mt20:xgsb}">继续扫码</van-button>
              <van-button round block type="primary" color="#0283ef" size="middle" class="mt20" @click="showpop=false" v-if="!xgsb">关闭</van-button>
          </div>
        </div>
      </van-popup>
  </div>
</template>

<script>
import wx from 'weixin-js-sdk'
import * as imageConversion from 'image-conversion';
import * as Minio from 'minio';
import axios from "axios";
export default {
  name: 'patrol',
  data () {
    return{
      typename:'',
      form:{
        shopName:'',
        buildName:'',
        pointName:'',
        floorName:'',
        memo:'',
        complete:0,
        total:0,
      },
      formtwo:{
        name:'',
        newtime:'',
        patrolUser:'',
        patrolUserName:'',
        pointStatus:false,
        patrolMemo:'',
        constructionUnit:'',
        constructionPersonnel:'',
        constructionMemo:'',
        dangerousMemo:'',
        picUrlList:[],
        picUrlListtwo:[],
        missionType:'',
        isshow:false,
        requiredPhoto:'',
      },
      show:false,
      list:[],
      list1:[],
      pointCode:this.$route.params.pointCode,
      uid:this.$route.params.uid,
      uname:this.$route.params.uname,
      token:this.$route.params.token,
      isuser:this.$route.params.isuser,
      // pointCode:'D2103101010002',
      newtime:'',
      newtimename:'',
      pointName:'',
      show:false,
      shopSid:'',
      loading:false,
      minioClient: null,
      selectedFile: null,
      showpop:false,
      txt:'巡更完成',
      xgwc:false,
      xgsb:false,
      bucketName:'',
      periodicType:this.$route.params.type
    }
  },
  created() { 
    let type=this.$route.params.type
    this.typename=type==1?'巡更':type==2?'保洁':type==3?'工程':'巡检'
    this.txt=type!=3?'任务':this.typename+'完成'
    document.title = this.typename+'管理'   
    const date = new Date();
		const year = date.getFullYear();
		const month = ('0' + (date.getMonth() + 1)).slice(-2); // 月份是从0开始的，所以要加1，并且保证是两位数
		const day = ('0' + date.getDate()).slice(-2); // 保证是两位数
		this.newtime=`${year}-${month}-${day}`;
		this.newtimename=`${year}/${month}/${day}`;
    this.getlist()
  },
  mounted(){
  },
  methods:{
    getshow(item){
      let that=this;
      if(item.patrolStatus>=0 && item.patrolStatus<=3 && item.isshow && that.isuser==2){
        if(that.bucketName==''){
          that.$toast('请先在后台配置图片存储信息')
          return
        }
        const date = new Date();
        const year = date.getFullYear();
        const month = ('0' + (date.getMonth() + 1)).slice(-2); // 月份是从0开始的，所以要加1，并且保证是两位数
        const day = ('0' + date.getDate()).slice(-2); // 保证是两位数
        that.newtime=`${year}-${month}-${day}`;
        if(item.itemList.length>0){
          item.itemList.filter((item, i) => {
            item.imgUrl=item.imgUrl && item.imgUrl!=null?item.imgUrl:''
            item.imgUrltwo=item.imgUrl && item.imgUrl!=null?[{url:item.imgUrl}]:[]
          })
        }
        that.formtwo={
          name:that.uname,
          newtime:that.newtime,
          patrolUser:that.uid,
          patrolUserName:that.uname,
          pointStatus:false,
          patrolMemo:'',
          constructionUnit:'',
          constructionPersonnel:'',
          constructionMemo:'',
          dangerousMemo:'',
          picUrlList:[],
          picUrlListtwo:[],
          missionType:item.missionType,
          sid:item.sid,
          requiredPhoto:item.requiredPhoto,
          itemList:item.itemList || []
        }
        that.show=true
        console.log(that.formtwo)
      }
		},
    gettot(){
      this.$toast('请上传图片');
    },
    goSubmit(values){
        let that=this
        that.loading=true
        that.xgwc=false
        that.xgsb=false
        let isvalue=true
        let form=JSON.parse(JSON.stringify(that.formtwo))
        if(form.itemList.length>0){
            form.itemList.filter((item, i) => {
              delete item.imgUrltwo
              if(item.itemValue==='' || item.itemValue==null){
                  isvalue=false
                  that.loading=false 
              }
            })
        }
        if(!isvalue){
            that.$toast('请选择点位确认项状态');
            return
        }
        form.picUrlList=that.formtwo.picUrlListtwo
        form.pointStatus=!that.formtwo.pointStatus?0:-1
        form.periodicType=that.$route.params.type
        that.$axios.put(process.env.API_HOST+"pms/app/patrol/daily/mission/point",form,{ 
            headers:{
                userTicket:this.token
            }
        }).then((res) => {
            that.loading=false
            if(res.data.state==200){
                that.getlist()
                that.txt=that.typename+'完成'
                that.showpop=true
                that.xgwc=true
                that.show=false
                console.log("提交成功")
            }else{
              that.txt=res.data.message || that.typename+'失败'
              that.showpop=true
              that.xgsb=true
                
            }
        }).catch((error) =>{
          that.loading=false
        });
    },
    dateNumber(sp=''){
        const date = new Date()
        const  year = date.getFullYear()
        const  month = date.getMonth()>9?date.getMonth()+1:'0'+(date.getMonth()+1)
        const  day = date.getDate();
        return year.toString()+month+day.toString()
    },
    getUUID () {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
            return (c === 'x' ? (Math.random() * 16 | 0) : ('r&0x3' | '0x8')).toString(16)
        })
    },
    beforeRead(file){
      if (file.type !== 'image/jpeg' && file.type !== 'image/jpg' && file.type !== 'image/png') {
        this.$toast('图片格式不正确');
        return false;
      }
      return new Promise((resolve) => {
          imageConversion.compressAccurately(file, 400).then(res => {
              let res2= new File([res], file.name, {
                type: res.type,
                lastModified: Date.now()
              });
              this.selectedFile=res2
              resolve(res);
          });
      })
    }, 
    afterRead(files, mindex) {
        let that=this;
        files.status = "uploading";
        files.message = "上传中...";
        const suffixType =that.selectedFile&&that.selectedFile.name?that.selectedFile.name.substr(that.selectedFile.name.lastIndexOf('.')):''
        const UrlName = `${that.dateNumber()}/${that.getUUID()}${suffixType}`
        // console.log('selectedFile',that.selectedFile.name)
        if (!that.selectedFile) return;
        that.minioClient.presignedPutObject(that.bucketName, UrlName, 24 * 60 * 60, function (err, presignedUrl) {
        axios.put(presignedUrl, that.selectedFile, {
            headers: {'Content-Type': that.selectedFile.type},
            timeout: 1000 * 60 * 30,
            onUploadProgress: function (progressEvent) {
                that.getFipstwo(UrlName)
                /** 返回文件当前上传的进度* */
                console.log({loaded:progressEvent.loaded,total:progressEvent.total,proNum:Number((progressEvent.loaded / progressEvent.total * 100).toFixed(0))})
                
            }
        }).then((res) => {
            that.$toast('上传成功')
            files.status = "";
            if(mindex===''){
                that.formtwo.picUrlListtwo.push({imgUrl:UrlName})
                return
            }
            that.formtwo.itemList[mindex].imgUrl=UrlName
            that.formtwo.itemList.push({})
            that.formtwo.itemList.pop()
            console.log(that.formtwo.itemList[mindex].imgUrltwo)
        }).catch((error) => {
            if(mindex===''){
                that.formtwo.picUrlList.splice(that.formtwo.picUrlList.length-1,1)
                that.$toast('上传失败')
                files.status = "";
                return
            }
            that.formtwo.itemList[mindex].imgUrl=''
            that.formtwo.itemList[mindex].imgUrltwo=[]
            that.formtwo.itemList.push({})
            that.formtwo.itemList.pop()
            that.$toast('上传失败')
            files.status = "";
        })
        })
    },
    deleteImg(file, detail,mindex) {
      if(mindex>=0){
        this.formtwo.itemList[mindex].imgUrl=''
        this.formtwo.itemList[mindex].imgUrltwo=[]
        
        this.formtwo.itemList.push({})
        this.formtwo.itemList.pop()
        return
      }
      this.formtwo.picUrlListtwo.splice(detail.index, 1)
    },
    async getFipstwo(UrlName){
        this.minioClient.presignedUrl('GET',this.bucketName, UrlName, function (err, presignedUrl) {
            console.log("图片地址地址",presignedUrl)
        })           
    },
    isInTimeRange(start,end) {
        let start1=start.replace(/-/g, '/')
        let end1=end.replace(/-/g, '/')
        const targetTime = new Date(start1);
        const targetTime1 = new Date(end1);
        const startTime = new Date(targetTime.getTime() - 5 * 60 * 1000); // 前5分钟
        const endTime = new Date(targetTime1.getTime() + 30 * 60 * 1000); // 后30分钟
        const currentTime = new Date();
        return currentTime >= startTime && currentTime <= endTime;
    },
    getlist(){
        let that = this
        let uid=that.isuser==2?that.uid:''
        that.$axios.get(process.env.API_HOST+"pms/app/patrol/daily/mission/qr-code?queryDay="+that.newtime+'&pointCode='+that.pointCode+'&outsidersSid='+uid+'&periodicType='+that.$route.params.type,{
            headers:{
                userTicket:that.token
            }
        }).then((res) => {
            if(res.data.state==200){
               that.form=res.data.data
                let zlist=res.data.data.missionPintList || []
                console.log('点位列表',zlist)
                let list1=[],list2=[]
                if(zlist.length>0){
                  zlist.filter((item, i) => {
                    item.isshow=that.isInTimeRange(item.missionStartTime,item.missionEndTime)
                    if(item.patrolStatus===0){
                      list1.push(item)
                    }else{
                      list2.push((item))
                    }
                  })
                }
                that.list=list1
                that.list1=list2
                that.$axios.get(process.env.API_HOST+"sysmanager/applets/os-config/shop?shopSid="+res.data.data.shopSid+'&osType='+that.$route.params.type,{
                    headers:{
                        userTicket:that.token
                    }
                }).then((res2) => {
                    if(res2.data.state==200){
                      if(!res2.data.data){
                        that.$toast('请先在后台配置图片存储信息')
                      }else{
                        that.bucketName=res2.data.data.bucketName || ''
                        that.minioClient = new Minio.Client({
                          // endPoint: res2.data.data.pathUrl,
                          //port: 80,
                          //useSSL: false,
                          endPoint: res2.data.data.pathUrl,
                          port: 443,
                          useSSL: true,
                          accessKey: res2.data.data.accessKey,
                          secretKey: res2.data.data.secretKey
                      });
                      }
                    }else{
                      that.$toast(res2,data.message)
                    }
                })
                // that.pointName=that.list.length>0?that.list[0].pointName:'任务点位详情'
            }else {
                that.$toast(res,data.message)
            }
        })			
    },
    getdata(val){
			return val!=''?val.split(' ')[0]:''
		},
		gettime(time){
			let rtime=time!=''?time.split(' ')[1]:''
			let times=rtime!=''?rtime.split(':'):''
			return times!=''?((times[0]+':'+times[1])=='00:00'?time.split(' ')[0]:(times[0]+':'+times[1])):''
		},
		getstateName(val){
			let name=val==0?('待'+(this.$route.params.type!=3?this.typename:'检查')):val==1?'未开始':val==2?('未'+(this.$route.params.type!=3?this.typename:'完成')):val==3?((this.$route.params.type!=3?this.typename:'任务')+'异常'):val==4?'已完成':val==-1?'已作废':''
			return name
		},
		getmissName(val){
			let name=val==0?'进行中':val==1?'未开始':val==2?('未'+(this.$route.params.type!=3?this.typename:'完成')):val==3?((this.$route.params.type!=3?this.typename:'任务')+'异常'):val==4?'已完成':val==-1?'已作废':''
			return name
		},
    goindex(){
      let that=this;
      wx.miniProgram.getEnv(function (res) {
        if (res.miniprogram) {
          wx.miniProgram.redirectTo({url: '/pages/index/index?type=saomiao&periodicType='+that.$route.params.type});
        }
      })
    },
    gourl(item){
      wx.miniProgram.getEnv(function (res) {
        if (res.miniprogram) {
          wx.miniProgram.navigateTo({url: '/package/patrol/detail?sid='+item.sid+'&isshow='+(item.isshow?1:2)});
          // wx.miniProgram.postMessage({data: {sid: item.sid}}); // 传的参数
        }
      });
      // this.$router.push({name: 'patroldetail', params: {sid: item.sid,uid:this.uid,uname:this.uname,token:this.token}})
      console.log(item)
    },
  },
}
</script>

<style scoped>
.max60{
  max-height: 60vh;
  overflow-y: auto;
}
.show_box{
  width: 80vw;
  background: #fff;
  box-sizing: border-box;
  padding:1rem 0.5rem ;
}
.show_box img{
    width: 2rem;
    height: 2rem;
    margin: 0 auto 0.2rem;
    display: block;
}
.show_box .txt{
  font-size: 0.6rem;
  color: #333;
  text-align: center;
  font-weight: bold;
}
.btnfoot{
  width: 80%;
  margin: 0.7rem auto 0;
}
.mt20{
  margin-top: 0.5rem;
}
.list{
		width: 100%;
		box-sizing: border-box;
		padding: 0.25rem 0;
		position: relative;
		z-index: 3;
		background: #FFFFFF;
		border-radius: 0.16rem;
		overflow: hidden;
	}
.list .item{
  width: 100%;
  background: #FFFFFF;
  box-sizing: border-box;
  padding: 0.2rem 0.25rem;
  border-bottom: 0.02rem solid #e4e7ed;
}
.list .item img{
  width: 0.5rem;
  height: 0.5rem;
  margin-right: 0.2rem;
}
.list .item:last-child{
  border-bottom: none;
}
.list .item .flex{
  position: relative;
}
.list .item .left{
  flex: 1;
  line-height: 160%;	
  font-size: 0.35rem;
  padding-right: 2rem;
}
.list .item .left .tname:last-child span{
  display: none;
}
.list .item .right{
  width: 2rem;
  height: 1rem;
  text-align: center;
  line-height: 1rem;
  background: #f29100;
  border-radius: 0.16rem;
  margin: 0 auto;
  font-size: 0.3rem;
  font-weight: 500;
  color: #FFFFFF;
  margin-top: 0.2rem;
  position: absolute;
  right: 0;
  z-index: 99;
}
.list .lvcolor{
  background: rgba(52,199,89,0.2);
  color: #34C759;
  border-bottom: 0.02rem solid #34C759;
}
.list .rcolor{
  background: rgba(255,59,48,0.2);
  color: #FF3B30;
  border-bottom: 0.02rem solid #FF3B30;
}
.list .bcolor{
  background: rgba(242, 145, 0, 0.2);
  color: #f29100;
  border-bottom: 0.02rem solid #f29100;
}
.pop_box >>> .van-cell-group--inset{
    margin: 0;
}
.scolor4{
    color: #04b46a;
}
.scolor2{
    color: #ff0000;
}
.scolor3{
    color: #9254de;
}
.scolor0{
    color: #1890ff;
}
.scolor1{
    color: #fa8c16;
}
.scolor0{
    color: #1a91ff;
}
.scolor5{
    color: #cccccc;
}
.btn_box{
    box-sizing: border-box;
    padding: 10px 16px 20px;
}
.row-end{
    width: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
}
.pop_box{
    box-sizing: border-box;
	/* padding: 0 0.25rem 0.45rem; */
}
.pop_box .title{
    font-size: 0.45rem;
    font-weight: bold;
    text-align: center;
    padding: 16px 0;
}
.title1{
  position: relative;
  font-size: 0.42rem;
  font-weight: bold;
  border-bottom: 0.02rem solid rgba(0, 0, 0, 0.2);
  box-sizing: border-box;
  padding: 0.3rem 0.5rem;
}
.title1::after{
  position: absolute;
  content: "";
  width: 0.12rem;
  height: 0.5rem;
  background: #6236FF;
  left: 0.2rem;
  top: 50%;
  margin-top: -0.25rem;
  border-radius: 0.18rem;
}
.topbox{
  width: 100%;
  background: #F8F8F8;
  box-sizing: border-box;
  padding: 0.4rem 0.25rem;
}
.pointbox{
  padding-bottom: 0.2rem;
  border-bottom: 0.02rem solid #797979;
}
.pointbox .left{
  flex: 1;
}
.pointbox .name{
  font-size: 0.52rem;
  font-weight: bold;
  color: #a30014;
  text-align: center;
  padding-bottom: 0.32rem;
  border-bottom: 0.06rem solid #797979;
  margin: 0 auto;
}
.pointbox .text{
  font-size: 0.32rem;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap; 
}
.pointbox .text div{
  min-width: 50%;
  margin-top: 0.15rem;
  box-sizing: border-box;
  padding-left: 0.2rem;
}
.pointbox .right{
  font-size: 0.28rem;
  width: 2.5rem;
  height: 2.5rem;
  background: #fff;
  flex-direction: column;
  margin-left: 0.4rem;
  box-sizing: border-box;
  border:0.02rem solid #797979;
  border-radius: 0.08rem;
  font-size: 0.36rem;
}

.pointbox .right div{
  margin-bottom: 0.1rem;
}
.pointbox .right .time{
  color: #000;
  font-size: 0.36rem;
}
.pointbox .right .num{
  font-size: 0.48rem;
  font-weight: bold;
  margin-bottom: 0;
}
.desc{
  display: flex;
  padding-top: 0.24rem;
}
.desc .left{
  width: 0.8rem;
  color: #a30014;
  font-weight: bold;
  font-size: 0.3rem;
}
.desc .left img{
  width: 0.7rem;
  height: 0.7rem;
}
.desc .right{
  margin-left: 0.2rem;
  flex: 1;
  background: #fff;
  border-radius: 0.08rem;
  box-sizing: border-box;
  padding: 0.2rem;
  border:0.02rem solid #797979;
  min-height: 2rem;
  font-size: 0.35rem;
}
.flex{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.flex-start{
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.flex-center{
  display: flex;
  align-items: center;
  justify-content: center;
}
.flex-end{
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
>>> .van-radio{
    margin-left: 8px;
}
</style>


// WEBPACK FOOTER //
// src/view/patrol.vue